export default "__VITE_ASSET__CK$Xm8W8__"